import {Pipe, PipeTransform} from '@angular/core';
import {find, lowerCase} from 'lodash';

import {
  booleanFilterOperators,
  dateFilterOperators,
  GridEditTemplate,
  numberFilterOperators,
  queryFilterOperators,
  stringFilterOperators,
  summaryDescriptionCnaFilterOperators
} from '../../../dialogs/models/create-new-view.enum';

@Pipe({
  name: 'formatOperator',
  pure: true
})
export class FormatOperatorPipe implements PipeTransform {
  transform(value: string, args?: any): string {
    const {editTemplate} = args.column;
    let operators: {title: string; value: string}[];

    switch (editTemplate) {
      case GridEditTemplate.integer:
        operators = numberFilterOperators;
        break;
      case GridEditTemplate.date:
        operators = dateFilterOperators;
        break;
      case GridEditTemplate.predefined:
        operators = booleanFilterOperators;
        break;
      case GridEditTemplate.query:
      case GridEditTemplate.tags:
      case GridEditTemplate.predefinedList:
        operators = queryFilterOperators;
        break;
      case GridEditTemplate.is_exists:
        operators = summaryDescriptionCnaFilterOperators;
        break;
      case GridEditTemplate.string:
        if (value === GridEditTemplate.is_exists) {
          operators = summaryDescriptionCnaFilterOperators;
        } else {
          operators = stringFilterOperators;
        }
        break;

      default:
        operators = stringFilterOperators;
    }

    const {title}: any = find(operators, {value});

    return lowerCase(title);
  }
}
